<template>
  <div>
    <div class="portlet-title">
      <div class="caption">
        <i class="icon-equalizer font-red-sunglo"></i>
        <span class="caption-subject font-red-sunglo bold uppercase">{{ trans('menu_planner_select.title') }}</span>
      </div>
    </div>
    <div class="portlet-body form">
      <div class="row">
        <div class="col-sm-2">
          <date-picker
            v-model="menuPlanner.date"
            :time="false"
          />
        </div>
        <div class="col-sm-3">
          <singleselect
            v-model="menuPlanner.brand"
            :checked="menuPlanner.brand"
            :options="availableBrands"
            :title="trans('menu_planner.entity.brand')"
            class="planner-multiselect"
            name="brand"
          />
        </div>
        <div class="col-sm-7">
          <button type="button" class="btn btn-success margin-right-10" :disabled="!isValid" @click="showMenu">
            <span class="glyphicon glyphicon-circle-arrow-right"></span>
            {{ trans('menu_planner_select.show') }}
          </button>
          <button type="button" class="btn btn-info" :disabled="!isValid" @click="editMenu">
            {{ trans('menu_planner_select.edit') }}
          </button>
          <menu-planner-history
              v-if="menuPlanner.brand && menuPlanner.date"
              :brand="menuPlanner.brand"
              :date="menuPlanner.date"
              route-name="api_get_entity_logger_show_menu_planner_meal"
              class="pull-right"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datePicker from '../datePicker.vue'
import singleselect from '../singleselect.vue'
import { NTFY_DE_ID, NTFY_ID } from '@const/common'
import MenuPlannerHistory from '@component/view/MenuPlannerHistory.vue'

export default {
  components: {
    MenuPlannerHistory,
    datePicker,
    singleselect,
  },
  props: {
    date: {
      type: [String, Date],
      default: '',
    },
    brand: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      menuPlanner: {
        date: this.date || moment().locale('pl').format('YYYY-MM-DD'),
        brand: this.brand,
      },
      loading: 0,
      progress: 0,
      brands: [],
      copyFromDate: moment().locale('pl').format('YYYY-MM-DD'),
    }
  },
  computed: {
    isValid() {
      return !isNaN(this.menuPlanner.brand) && Boolean(this.menuPlanner.date) !== false
    },
    availableBrands() {
      return this.brands.filter(item => item.id === NTFY_ID || item.id === NTFY_DE_ID)
    },
  },
  watch: {
    'date'(val) {
      this.menuPlanner.date = val
    },
    'brand'(val) {
      this.menuPlanner.brand = val
    },
    availableBrands(val) {
      this.$store.commit('setAvailableBrands', val)
    },
  },
  mounted() {
    this.getBrands()
  },
  methods: {
    showMenu() {
      this.$router.push({
        name: 'menu-planner-select-show',
        params: {
          date: this.menuPlanner.date,
          brand: this.menuPlanner.brand,
        }
      })
    },
    editMenu() {
      this.$router.push({
        name: 'menu-planner-select-edit',
        params: {
          date: this.menuPlanner.date,
          brand: this.menuPlanner.brand,
          showDate: this.menuPlanner.date,
        }
      })
      this.$router.go()
    },
    getBrands() {
      let url = Routing.generate('api_get_brands', { context: 'dropdown' })
      this.loading++
      this.progress++
      this.$http.get(url).then(response => {
        this.brands = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    trans(id) {
      return Translator.trans(id)
    },
  },
}
</script>

<style>
.planner-multiselect > .multiselect {
  min-height: unset;
}

.planner-multiselect > .multiselect > .multiselect__tags {
  min-height: unset;
  padding: 6px 40px 0 8px;
  border: 1px solid #ccc;
}

.portlet-title {
  border-bottom: 1px solid #eef1f5;
  padding: 0;
  min-height: 48px;
  margin-bottom: 10px;
}

.portlet-title > .caption {
  float: left;
  display: inline-block;
  font-size: 18px;
  line-height: 18px;
  padding: 10px 0;
  font-weight: 400;
}

.portlet-title > .caption > span {
  font-size: 16px;
}

.portlet-title > .caption > i {
  font-size: 15px;
  font-weight: 300;
  margin-top: 3px;
}
</style>
